import * as React from 'react';
import cx from 'classnames';
import { polymorphic, Box } from '../../utils/index.js';
import { LinkAction } from '../LinkAction/LinkAction.js';
let ListItemComponent = React.forwardRef((props, ref) => {
  let {
    size = 'default',
    disabled = false,
    active = false,
    actionable = false,
    focused = false,
    className,
    ...rest
  } = props;
  return React.createElement(Box, {
    role: 'listitem',
    className: cx('iui-list-item', className),
    'data-iui-active': active ? 'true' : void 0,
    'data-iui-disabled': disabled ? 'true' : void 0,
    'data-iui-size': 'large' === size ? 'large' : void 0,
    'data-iui-actionable': actionable ? 'true' : void 0,
    'data-iui-focused': focused ? 'true' : void 0,
    ref: ref,
    ...rest,
  });
});
ListItemComponent.displayName = 'ListItem';
let ListItemIcon = polymorphic.div('iui-list-item-icon');
ListItemIcon.displayName = 'ListItem.Icon';
let ListItemContent = polymorphic.div('iui-list-item-content');
ListItemContent.displayName = 'ListItem.Content';
let ListItemDescription = polymorphic.div('iui-list-item-description');
ListItemDescription.displayName = 'ListItem.Description';
let ListItemAction = LinkAction;
ListItemAction.displayName = 'ListItem.Action';
export const ListItem = Object.assign(ListItemComponent, {
  Icon: ListItemIcon,
  Content: ListItemContent,
  Description: ListItemDescription,
  Action: ListItemAction,
});
